import React, { Component } from 'react'
import { Row, Col, Card, CardGroup, Button, Form, Container } from "react-bootstrap";
import { components } from 'react-select'
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import { graphql } from "react-apollo";
import * as compose from 'lodash.flowright';
import * as Cookies from "es-cookie";
import SelectBoxWithDisabledOption from '../../selectdropdown/SelectBoxWithDisabledOption';
import '../_quiz.scss';
import Duration from '../../../../images/duration.png'
import Absent from '../../../../images/absent.png'
import Attended from '../../../../images/attended.png'
import AverageScore from '../../../../images/averagescore.png'
import CardLessDataTableWithOutSearch from '../../datatables/CardLessDataTableWithOutSearch';
import TotalStudentDataModal from '../../quiz_section/quiz_summary/totalStudentDataModal.jsx';
import SingleStudentDataModal from '../../quiz_section/quiz_summary/singelStudentDataModal.jsx';
import parse, { domToReact } from 'html-react-parser';

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-6q0nyr-Svg"><path fill="currentColor" d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path></svg>
            </components.DropdownIndicator>
        )
    );
};

const SelectStudentType = [
    { value: 0, label: 'All' },
    { value: 1, label: 'Free' },
    { value: 2, label: 'Subscribed' }

];

class ExamsSummarySection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            viewType: "ongoing",
            getExamPaperTypeOptions: [],
            examPaperTypevalue: { value: "5", label: "Crash Course Quiz" },
            examName: "",
            examNameErrMsg: "",
            ongoingExams: [],
            completedExams: [],
            examValue: "",
            examNameValue: "",
            showSpinner: "hide",
            getEamcetCrashCourseResults: "",
            attempted_exam: "attended",
            started_exam: "Started",
            studentType: 0,
            studentTypeValue: { value: "0", label: "All" },
            studentTypeErrMsg: "",
            studentResults: [],
            totalStudentDataShow: false,
            singleStudentDataShow: false,
            mobile: "",
            slno: ''
        }
    }


    handleSelect(val) {
        this.setState({
            viewType: val,
            getEamcetCrashCourseResults: "",
            examNameValue: "",
            studentTypeValue: { value: "0", label: "All" },
            started_exam: "Started",
            examPaperTypevalue: { value: "5", label: "Crash Course Quiz" }
        })
    }

    handleSelect1(val) {
        this.setState({
            attempted_exam: val,
        });
    }

    handleSelect2(val) {
        this.setState({
            started_exam: val
        })
    }


    componentDidMount() {
        let examPaperType1Arr = [];
        let ongoingexamNamesArr = [];
        let completedexamNamesArr = [];
        let current_time = moment().unix()


        for (let i = 0; i <= this.props.getExamModelTypes.length; i++) {
            let idata = this.props.getExamModelTypes[i];
            if (idata != undefined) {
                const newObj = {
                    value: idata.id,
                    label: idata.exam_model,
                }

                examPaperType1Arr.push(newObj);
            }
        }

        this.props.getEamcetCourseExams.map((item) => {

            let examDate = moment.unix(item.start_time).format("MMMM DD YYYY")
            let examDateFormat = moment.unix(item.start_time).format("MM-DD-YYYY")
            let examDateFormatUnix = moment(examDateFormat, 'MM-DD-YYYY').unix();


            if (current_time >= item.start_time && current_time <= item.end_time) {
                const newobjOngoing = {
                    value: item.id,
                    label: item.exam_name + ' ( ' + examDate + ' ) ',
                    start_time: item.start_time,
                    examDateFormat: examDateFormat,
                    examDateFormatUnix: examDateFormatUnix,
                    end_time: item.end_time,
                    exam_model_type_id: item.exam_model_type_id
                }

                ongoingexamNamesArr.push(newobjOngoing)
                this.setState({
                    ongoingExams: ongoingexamNamesArr,
                    examValue: {
                        value: item.id,
                        label: item.exam_name
                    }
                })
            } else if (current_time > item.end_time) {
                const newobjCompleted = {
                    value: item.id,
                    label: item.exam_name + ' ( ' + examDate + ' ) ',
                    start_time: item.start_time,
                    examDateFormat: examDateFormat,
                    examDateFormatUnix: examDateFormatUnix,
                    end_time: item.end_time,
                    exam_model_type_id: item.exam_model_type_id
                }
                completedexamNamesArr.push(newobjCompleted)
                this.setState({
                    completedExams: completedexamNamesArr,
                    examValue: {
                        value: item.id,
                        label: item.exam_name
                    }
                })
            }
        })
        this.setState({
            getExamPaperTypeOptions: examPaperType1Arr
        });
    }

    totalStudentResults = (data) => {
        // console.log("sssssssss", data)
        this.setState({
            started_exam: "totalStudentResults",
            totalStudentDataShow: true,
            slno: data
        })
    }

    selecthandleInputChange = async (ename, evalue) => {

        const name = ename;
        const value = evalue;

        // console.log("hhhhhh", value, name)

        if (name == "examPaperType") {
            let examModel1Types = this.props.getExamModelTypes.find((a) => a.id == value);
            this.setState({
                examPaperTypevalue: {
                    value: examModel1Types.id,
                    label: examModel1Types.exam_model
                },
                getEamcetCrashCourseResults: "",
                examNameValue: "",
            });
        }

        if (name == "examName") {
            let examNameTypes = this.props.getEamcetCourseExams.find((a) => a.id == value)
            this.setState({
                examNameValue: {
                    value: examNameTypes.id,
                    label: examNameTypes.exam_name
                },
                getEamcetCrashCourseResults: "",
                attempted_exam: "attended",
                started_exam: "Started",
            })
        }

        if (name == "studentType") {
            let labelVal = ""
            if (value == 0) {
                labelVal = 'All'
            } else if (value == 1) {
                labelVal = 'Free'
            } else {
                labelVal = 'Subscribed'
            }
            this.setState({
                studentTypeValue: {
                    value: value,
                    label: labelVal
                },
                getEamcetCrashCourseResults: "",
                studentTypeErrMsg: "",
                started_exam: "Started",
            })
        }
        this.setState({ [name]: value });
    }

    getSummaryDetails = async () => {

        this.setState({
            examNameErrMsg: "",
            studentTypeErrMsg: "",

        })

        if (this.state.examNameValue == "") {
            this.setState({ examNameErrMsg: "Please Select Exam" })
            return;
        }
        else if (this.state.studentTypeValue == "") {
            this.setState({ studentTypeErrMsg: "Select student Type" })
            return;
        }

        this.setState({ showSpinner: "show" });

        const result = await this.props.client.query({
            query: gql` 
            query(
                $institution_id:Int!
                $exam_paper_id:Int!,
                $type:String!
            ){
                getEamcetCrashCourseResults(
                    institution_id:$institution_id
                    exam_paper_id:$exam_paper_id,
                    type:$type
                ){
                    id
                    exam_name
                    exam_model_type_id
                    attended_count
                    total_students
                    scheduled_time
                    marks
                    completed_count
                    duration
                    results{
                    student_name
                    correct_marks
                    negative_marks
                    attempted_exam
                    rank
                    studentAvg
                    is_started
                    is_completed
                    mobile
                    student_exam_type
                    }
                }
            }
            `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_paper_id: this.state.examNameValue.value,
                type: this.state.studentTypeValue.label
            },
            fetchPolicy: 'network-only'
        })

        const studentResults = await this.props.client.query({
            query: gql` 
                query(
                    $exam_paper_id:Int!,
                    $type:String
                    $institution_id:Int
                    ) {
                      getStudent_correct_wrong_results(
                           exam_paper_id: $exam_paper_id,
                           type:$type,
                           institution_id:$institution_id
                        )
                        {
                            slno
                            question
                            option1
                            option2
                            option3
                            option4
                            answer
                            qtype
                            question_id
                            list1type
                            list2type
                            correct_count
                            wrong_count
                            unanswered_count
                            studentResults {
                              name
                              attempt_answer
                              isCorrect
                              mobile
                            }
                    }
                }
              `,
            variables: {
                institution_id: parseInt(Cookies.get("institutionid")),
                exam_paper_id: this.state.examNameValue.value,
                type: this.state.studentTypeValue.label
            },
            fetchPolicy: 'network-only'
        });
        // console.log("results", studentResults)

        if (result.data.getEamcetCrashCourseResults != undefined) {
            this.setState({
                showSpinner: "hide",
                getEamcetCrashCourseResults: result.data.getEamcetCrashCourseResults,
            })
        }

        if (studentResults.data.getStudent_correct_wrong_results != undefined) {
            this.setState({
                studentResults: studentResults.data.getStudent_correct_wrong_results,
            });
        }

    }

    articlecolumns = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "student_type",
            text: "Student Type",
            sort: true,
        },
        {
            dataField: "studentAvg",
            text: "Overall Average",
            sort: true

        },
	{
            dataField: "score",
            text: "Score",
            sort: true,
        },
        {
            dataField: "rank",
            text: "Rank",
            sort: true
        },

    ];
    articleColumnsResults = [
        {
            dataField: "student_name",
            text: "Student Name",
            sort: true,
        },
        {
            dataField: "studentAvg",
            text: "Overall Average",
            sort: true

        },
        {
            dataField: "score",
            text: "Score",
            sort: true,
        },
        {
            dataField: "rank",
            text: "Rank",
            sort: true
        },
        {
            dataField: "mobile",
            text: "Result",
            formatter: this.actionFormatterStudentName.bind(this)
        },
    ];

    questionColumns = [
        {
            dataField: "index",
            text: "SLNO",
        },
        {
            dataField: "questionID",
            text: "question",
            formatter: this.actionFormatterQuestionData.bind(this),
        },
        {
            dataField: "correctCount",
            text: "Correct",
            sort: true
        },
        {
            dataField: "wrongCount",
            text: "Wrong",
            sort: true
        },
        {
            dataField: "unanswered",
            text: "Unanswered",
            sort: true,
        },
        {
            dataField: "slno",
            text: "Results",
        },
    ];

    rankDefaultsorted = [
        {
            dataField: "rank",
            order: "ASC"
        }
    ];

    actionFormatterQuestionData(rowData) {
        let questionData = this.state.studentResults.filter((item) => item.question_id == rowData);

        if (questionData[0].qtype == "9" || questionData[0].qtype == "3") {
            let question1 = questionData[0].question.replace(/src="/g, 'src=\\"');
            let question2 = question1.replace(/" \/>/g, '\\" />');
            let question = [];
            try {
                question = JSON.parse(question2);
            }
            catch (err) {
                console.log("MATRIX ERROR:", err.message);
            }

            return (
                <Card as={Card.Body} className="bg-light my-2">
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <h6 className='text-center font-weight-bold'>List-I</h6>
                            <ol className="matrixlistoptions" type={
                                questionData[0].list1type == "alphabets" ? ("A")
                                    : (questionData[0].list1type == "numbers") ? ("1")
                                        : ("roman")}
                            >
                                {question.map((item) => (
                                    <li className='font-weight-bold'>{parse(item.qlist1)}</li>
                                ))}
                            </ol>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <h6 className='text-center font-weight-bold'>List-II</h6>
                            <ol className="matrixlistoptions" type={
                                questionData[0].list2type == "alphabets" ? ("A")
                                    : (questionData[0].list2type == "numbers") ? ("1")
                                        : ("roman")}>
                                {question.map((item) => (
                                    <li className='font-weight-bold' >{parse(item.qlist2)}</li>
                                ))}
                            </ol>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>)
        }
        else if (questionData[0].qtype == "8") {
            return (
                <Card as={Card.Body} className="bg-light my-2">
                    {parse(questionData[0].question)}
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )

        }
        else if (questionData[0].qtype == "5") {
            //console.log("questionsData.questionnn", question);
            return (<Card as={Card.Body} className="bg-light my-2">
                {parse(questionData[0].compquestion)}
                {parse(questionData[0].question)}
                <Row>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>A.</span>
                            <div className="ml-2">{parse(questionData[0].option1)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>B.</span>
                            <div className="ml-2">{parse(questionData[0].option2)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>C.</span>
                            <div className="ml-2">{parse(questionData[0].option3)}</div>
                        </div>
                    </Col>
                    <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                        <div className="d-flex align-items-center">
                            <span className='f-16'>D.</span>
                            <div className="ml-2">{parse(questionData[0].option4)}</div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xl={12} lg={12} md={12} sm={12} className="my-2 ">
                        <div className="d-flex align-items-center color_000">
                            <span className="font-weight-bold">Correct Answer:</span>
                            <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                        </div>
                    </Col>
                </Row>

            </Card>)
        }
        else {
            return (
                <Card as={Card.Body} className="bg-light my-2 questionData">
                    {<span className='font-weight-bold'> {parse(questionData[0].question)}</span>}
                    <Row className="my-3">
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>A.</span>
                                <div className="ml-2">{parse(questionData[0].option1)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>B.</span>
                                <div className="ml-2">{parse(questionData[0].option2)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>C.</span>
                                <div className="ml-2">{parse(questionData[0].option3)}</div>
                            </div>
                        </Col>
                        <Col xl={6} lg={6} md={6} sm={12} className="my-2">
                            <div className="d-flex align-items-center">
                                <span className='f-16'>D.</span>
                                <div className="ml-2">{parse(questionData[0].option4)}</div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xl={12} lg={12} md={12} sm={12} className="my-2">
                            <div className="d-flex align-items-center color_000">
                                <span className="font-weight-bold">Correct Answer:</span>
                                <div className="font-weight-bold ml-2">{questionData[0].answer}</div>
                            </div>
                        </Col>
                    </Row>

                </Card>
            )
        }
    }


    actionFormatterStudentName(row) {
        // console.log('row', row)
        return (<>

            <a onClick={() => this.singleStudentResult(row)}>
                <p style={{ color: "blue" }}>View Results</p>
            </a>

        </>)
    }

    singleStudentResult = (row) => {
        this.setState({
            singleStudentDataShow: true,
            mobile: row
        })
    }

    tableData(students) {
        const student_data = Array();
        for (let i = 0; i < students.length; i++) {
            student_data.push({
                student_name: students[i].student_name,
                student_type: students[i].student_exam_type,
                score: students[i].correct_marks - students[i].negative_marks,
                rank: students[i].rank,
                studentAvg: students[i].studentAvg,
                mobile: students[i].mobile
            });
        }
        return student_data;
    }


    resultData(resultData) {
        console.log("data", resultData);
        const question_data = Array();
        for (let i = 0; i < resultData.length; i++) {
            question_data.push({
                index: i + 1,
                correctCount: resultData[i].correct_count,
                wrongCount: resultData[i].wrong_count,
                unanswered: resultData[i].unanswered_count,
                questionID: resultData[i].question_id,
                slno: <a onClick={() => this.totalStudentResults(resultData[i].slno)} style={{ color: "blue" }}>View</a>,

            });
        }
        return question_data;
    }


    render() {
         console.log("chaitu", this.props)

        let stateFilterData1 = [];
        let ongoingFilterData1 = [];
        let totalReslutArray = [];
        if (this.state.getEamcetCrashCourseResults != "") {
            let filterData = this.state.getEamcetCrashCourseResults.filter(item2 => item2.id == this.state.examNameValue.value);
            let stateFilterData = [];
            if (filterData.length > 0) {
                stateFilterData = filterData[0].results.map((item) => {
                    if (item != undefined) {
                        return item
                    }
                })
            }

            if (this.state.started_exam == "Started") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_started == true)
            } else if (this.state.started_exam == "NotStarted") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_started == false)
            } else if (this.state.started_exam == "Completed") {
                stateFilterData1 = stateFilterData.filter((item) => item.is_completed == true)
            } else if (this.state.started_exam == "totalStudentResults") {
                totalReslutArray = this.state.studentResults
            }


            if (this.state.started_exam == "Started") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_started == true)
            } else if (this.state.started_exam == "NotStarted") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_started == false)
            } else if (this.state.started_exam == "Completed") {
                ongoingFilterData1 = stateFilterData.filter((item) => item.is_completed == true)
            } else if (this.state.started_exam == "totalStudentResults") {
                totalReslutArray = this.state.studentResults
            }
        }
        return (
            <section>
                <Container fluid>
                    <Row>
                        <Col>
                            <ul className='list-inline question_sel_cls mt-3'>
                                <li className={this.state.viewType == "ongoing" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("ongoing")}>Ongoing</li>
                                <li className={this.state.viewType == "completed" ? "active mr-4" : "mr-4"} onClick={() => this.handleSelect("completed")}>Completed</li>
                            </ul>
                        </Col>
                    </Row>

                    <Form>
                        <Row className='mt-3'>
                            <Col sm={3}>
                                <Form.Label className="font-weight-bold">Exam Paper Type</Form.Label>
                                <SelectBoxWithDisabledOption
                                    stateData={this.state.examPaperTypevalue}
                                    name="examPaperType"
                                    placeholderName={'Exam Paper Type'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    options={this.state.getExamPaperTypeOptions}
                                    handleChange={this.selecthandleInputChange}
                                />
                            </Col>

                            <Col sm={3}>
                                <Form.Label className="font-weight-bold">Exam Name <span className='errorCls'>{this.state.examNameErrMsg}</span></Form.Label>
                                <SelectBoxWithDisabledOption
                                    stateData={this.state.examNameValue}
                                    name="examName"
                                    placeholderName={'Exam Name'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    options={this.state.viewType == "ongoing" ? this.state.ongoingExams.filter(item => item.exam_model_type_id == this.state.examPaperTypevalue.value) : this.state.completedExams.filter(item => item.exam_model_type_id == this.state.examPaperTypevalue.value)}
                                    handleChange={this.selecthandleInputChange}
                                />
                            </Col>

                            <Col sm={3}>
                                <Form.Label className="font-weight-bold">Student Type <span className='errorCls'>{this.state.studentTypeErrMsg}</span></Form.Label>
                                <SelectBoxWithDisabledOption
                                    stateData={this.state.studentTypeValue}
                                    name="studentType"
                                    placeholderName={'Select Student Type'}
                                    dropdownIndicator={{ DropdownIndicator }}
                                    options={SelectStudentType}
                                    handleChange={this.selecthandleInputChange}
                                />
                            </Col>

                            <Col sm={3}>
                                <Form.Group>
                                    <Button type="button" className="btn btn-light-blue float-right mt-4" onClick={() => this.getSummaryDetails()}>Get Details</Button>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>

                    {
                        this.state.getEamcetCrashCourseResults == "" ?
                            (
                                <Row>
                                    <Col sm={12} className={this.state.showSpinner == "show" ? "showSpinnerCls text-center mt-5" : "hideSpinnerCls text-center"}>
                                        <div class="spinner-border text-primary text-center loading-img-center"></div>
                                    </Col>
                                </Row>
                            )
                            :
                            ("")
                    }


                    {
                        this.state.getEamcetCrashCourseResults != "" ?
                            (
                                <>
                                    <h4 className='mt-4 text-center text-capitalize'>Exam Name ( <span className='color_blue'>{this.state.getEamcetCrashCourseResults[0].exam_name}</span> )</h4>
                                    <Row className='mt-5'>
                                        <Col>
                                            <div>
                                                <h5>Summary</h5>
                                                <div className='mainBlockUl mt-2'>
                                                    <ul className='list-inline blocksLi'>
                                                        <li class="color_bg_white br_yellow">
                                                            <div class="row">
                                                                <div class="col-sm-9">
                                                                    <h6 class="font_16">Duration</h6>
                                                                </div>
                                                                <div class="col-sm-3 float-right">
                                                                    <i class="far fa-clock f-24 bg_yellow"></i>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].duration + ' Mins'}</h5>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li class="color_bg_white br_green">
                                                            <div class="row">
                                                                <div class="col-sm-9">
                                                                    <h6 class="font_16">Started</h6>
                                                                </div>
                                                                <div class="col-sm-3 float-right">
                                                                    <i class="far fa-user-check f-24 bg_green left_pos"></i>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].attended_count + "/" + this.state.getEamcetCrashCourseResults[0].total_students}</h5>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li class="color_bg_white br_red">
                                                            <div class="row">
                                                                <div class="col-sm-9">
                                                                    <h6 class="font_16">Not Started</h6>
                                                                </div>
                                                                <div class="col-sm-3 float-right">
                                                                    <i class="far fa-user-times f-24 bg_red left_pos"></i>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].total_students - this.state.getEamcetCrashCourseResults[0].attended_count + '/' + this.state.getEamcetCrashCourseResults[0].total_students}</h5>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li class="color_bg_white br_black">
                                                            <div class="row">
                                                                <div class="col-sm-9">
                                                                    <h6 class="font_16">Completed</h6>
                                                                </div>
                                                                <div class="col-sm-3 float-right">
                                                                    <i class="fas fa-file-alt f-24 bg_blue"></i>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <h5 className='mt-2 text-center'>{this.state.getEamcetCrashCourseResults[0].completed_count}</h5>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li class="color_bg_white br_orange">
                                                            <div class="row">
                                                                <div class="col-sm-8">
                                                                    <h6 class="font_16">Marks</h6>
                                                                </div>
                                                                <div class="col-sm-4 float-right">
                                                                    <i class="far fa-file-alt f-24 bg_orange"></i>
                                                                </div>
                                                                <div class="col-sm-12">
                                                                    <h5 class="mt-2 text-center">{this.state.getEamcetCrashCourseResults[0].marks}</h5>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        {
                                            this.state.viewType == "completed" ?
                                                (
                                                    <>
                                                        <Col sm={3} className='mt-5'>
                                                            <h5 className='mt-2'>Student Details</h5>
                                                        </Col>
                                                        <Col sm={9} className='mt-5'>
                                                            <ul className='d-flex justify-content-end question_sel_cls'>
                                                                {
                                                                    this.state.studentTypeValue.label == "Subscribed" ?
                                                                        (
                                                                            <>

                                                                                <li className={this.state.started_exam == "Started" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Started")}>Started</li>
                                                                                <li className={this.state.started_exam == "NotStarted" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("NotStarted")}>Not Started</li>
                                                                                <li className={this.state.started_exam == "Completed" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Completed")}>Completed</li>
                                                                                <li className={this.state.started_exam == "totalStudentResults" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("totalStudentResults")}>Result Analysis</li>

                                                                            </>
                                                                        )
                                                                        :
                                                                        (
                                                                            <>

                                                                                <li className={this.state.started_exam == "Started" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Started")}>Started</li>
                                                                                <li className={this.state.started_exam == "Completed" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Completed")}>Completed</li>
                                                                                <li className={this.state.started_exam == "totalStudentResults" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("totalStudentResults")}>Result Analysis</li>

                                                                            </>
                                                                        )
                                                                }
                                                            </ul>
                                                        </Col>
                                                    </>
                                                )
                                                :
                                                (
                                                    <>
                                                        <Col sm={3} className='mt-5'>
                                                            <h5 className='mt-2'>Student Details</h5>
                                                        </Col>
                                                        <Col sm={9} className='mt-5'>
                                                            <ul className='d-flex justify-content-end question_sel_cls'>
                                                                <li className={this.state.started_exam == "Started" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Started")}>Started</li>
                                                                {this.state.studentTypeValue.label == "Subscribed" ? (<li className={this.state.started_exam == "NotStarted" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("NotStarted")}>Not Started</li>) : ("")}
                                                                <li className={this.state.started_exam == "Completed" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("Completed")}>Completed</li>
                                                                <li className={this.state.started_exam == "totalStudentResults" ? "active mr-2" : "mr-2"} onClick={() => this.handleSelect2("totalStudentResults")}>Result Analysis</li>
                                                            </ul>
                                                        </Col>
                                                    </>
                                                )
                                        }
                                    </Row>

                                    <Row className='table_bottom'>
                                        <Col sm={12}>
                                            <CardLessDataTableWithOutSearch
						stateData={this.state}
                                                parentData={this.state.started_exam == "totalStudentResults" ? this.resultData(totalReslutArray) : this.state.viewType == "completed" ? this.tableData(stateFilterData1) : this.tableData(ongoingFilterData1)}
                                                particlecolumns={this.state.started_exam == "totalStudentResults" ? this.questionColumns : this.state.started_exam != "Completed" ? this.articlecolumns : this.articleColumnsResults}
                                                defaultSorted={this.rankDefaultsorted}
                                            />
                                        </Col>
                                    </Row>
                                </>
                            )
                            :
                            ("")
                    }

                </Container>
                <TotalStudentDataModal
                    show={this.state.totalStudentDataShow}
                    onHide={() => this.setState({ totalStudentDataShow: false })}
                    data={this.state}
                />
                <SingleStudentDataModal
                    show={this.state.singleStudentDataShow}
                    onHide={() => this.setState({ singleStudentDataShow: false })}
                    stateData={this.state}
                />
            </section>
        )
    }

}

export default withRouter(withApollo(ExamsSummarySection));
